import { yupResolver } from '@hookform/resolvers/yup'
import React, { useContext, useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { editMainCleaner } from '../../../../redux/slices/propertySlice'
import { useDispatch, useSelector } from 'react-redux'
import { SpinnerContext } from '../../../../context/spinnerContext'
import { errorToast, successToast } from '../../../../util/Toast/toast'
import { getAllCleanersName } from '../../../../redux/slices/cleanersSlice'
import { mainCleanerSchema } from '../../../../util/validationSchema'
import Select from 'react-select'

const EditMainCleaner = ({ propertyId, setIsRefresh, toggleMainCleanerModal, propertyData }) => {
  const dispatch = useDispatch()
  const { changeLoader } = useContext(SpinnerContext)
  const { allCleanersName } = useSelector(({ cleaners }) => cleaners)
  const {
    handleSubmit,
    control,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(mainCleanerSchema),
    defaultValues: {
      cleaners_id: propertyData?.cleaners
    }
  })

  useEffect(() => {
    const fetchData = async () => {
      changeLoader(true)
      const payload = { properties_id: propertyId }
      try {
        dispatch(getAllCleanersName(payload))
      } catch (err) {
        console.error('Error fetching data:', err)
      } finally {
        changeLoader(false)
      }
    }
    fetchData()
  }, [propertyId])

  const onSubmit = (data) => {
    const payload = {
      property_id: propertyId,
      data: {
        cleaners_id: data?.cleaners_id?.cleaners_id
      }
    }
    setIsRefresh(false)
    changeLoader(true)
    if (propertyId) {
      dispatch(editMainCleaner(payload)).then(({ payload, error }) => {
        if (payload?.status === 200) {
          toggleMainCleanerModal()
          setIsRefresh(true)
          changeLoader(false)
          successToast(payload?.data?.status_message || 'Success!')
        } else {
          errorToast(payload?.data?.status_message || error?.message)
          changeLoader(false)
        }
      })
    }
  }

  return (
    <div className="container-fluid">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-lg-12 col-sm-12">
            <div className="form-group input_text border-remove">
              <label>
                Main Cleaner<span className="text-danger"> *</span>
              </label>
              <Controller
                name="cleaners_id"
                control={control}
                render={({ field }) => (
                  <>
                    <Select
                      {...field}
                      className={`react-selectcomponent form-control select-box-filed ${errors?.cleaners_id ? 'error-input' : ''}`}
                      getOptionLabel={(option) => `${option.first_name} ${option.last_name}`}
                      getOptionValue={(option) => `${option.cleaners_id}`}
                      options={allCleanersName || []}
                      isClearable
                      isSearchable={true}
                      placeholder={`Select Main Cleaner`}
                      classNamePrefix="select_kanakku"
                      defaultValue={''}
                    />
                    <small>{errors?.cleaners_id?.message}</small>
                  </>
                )}
              />
            </div>
          </div>
          {/* <div className="col-lg-12 col-sm-12">
            <div className="form-group">
              <label>
                Main Cleaner<span className="text-danger"> *</span>
              </label>
              <Controller
                name="main_cleaner"
                control={control}
                render={({ field: { value, onChange }, fieldState }) => (
                  <>
                    <input
                      className="form-control"
                      value={value ? value : ''}
                      type="text"
                      placeholder="Enter Main Cleaner"
                      onChange={(val) => {
                        onChange(val)
                        trigger('main_cleaner')
                      }}
                    />
                    <small>{fieldState?.error?.message}</small>
                  </>
                )}
              />
            </div>
          </div> */}
        </div>
        <div className="row mb-3">
          <div className="multi_btn_div">
            <button type="button" className="btn common-outline-btn w-100" onClick={() => toggleMainCleanerModal()}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary common-field-btn w-100">
              {`Update`}
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default EditMainCleaner
